<template>
    <RegionsList/>
</template>

<script>
import RegionsList from '../../components/regions/RegionsList';

export default {
  components: {
    RegionsList,
  },
};
</script>
